export default function Intro() {
  return (
    <section data-testid="intro-section" className="py-24 md:py-36">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-6 md:gap-10">
        <div className="col-span-12 md:col-span-3">
          <span className="overline">01 — Who we are</span>
        </div>
        <div className="col-span-12 md:col-span-9">
          <h2
            data-testid="intro-headline"
            className="font-serif-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.01em] max-w-4xl"
          >
            A media &amp; brand agency built for{" "}
            <span className="italic-display text-[#c9a878]">real estate.</span>
          </h2>

          <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 text-[15px] md:text-[17px] leading-[1.75] text-[#3a3a3a]">
            <p>
              We partner with real estate agents and agencies to make the
              content side of the business feel effortless. Two things we do
              well: on-the-ground listing coverage, and long-term brand and
              creative work — from single-shoot to full-agency partner.
            </p>
            <p>
              Our{" "}
              <span className="italic-display text-black">listing content</span>{" "}
              is local to <span className="italic-display text-black">Maine &amp; New Hampshire</span>.
              Our <span className="italic-display text-black">agency work</span>{" "}
              — brand, film, strategy — is available locally and to clients{" "}
              <span className="italic-display text-black">across the country</span>.
            </p>
          </div>

          {/* At-a-glance strip */}
          <div className="mt-12 md:mt-16 border-t border-black/10 grid grid-cols-1 md:grid-cols-2">
            <a
              href="#services"
              data-testid="intro-listings-link"
              className="group py-6 md:py-8 md:pr-8 border-b md:border-b-0 md:border-r border-black/10 transition-colors duration-300 hover:bg-black/[0.02]"
            >
              <div className="flex items-center justify-between">
                <span className="overline">Listing content</span>
                <span
                  aria-hidden
                  className="text-black/40 group-hover:text-[#c9a878] transition-all duration-500 group-hover:translate-x-1"
                >
                  →
                </span>
              </div>
              <p className="mt-2 font-serif-display text-2xl md:text-3xl transition-transform duration-500 group-hover:translate-x-1">
                Maine &amp; <span className="italic-display">New Hampshire</span>
              </p>
              <p className="mt-2 text-[13px] text-[#5a6470]">
                Photo · Video · Drone · Matterport · Floor plans
              </p>
              <span className="mt-3 inline-block overline text-black/50 group-hover:text-[#c9a878] transition-colors">
                Explore listings ↘
              </span>
            </a>

            <a
              href="#agency"
              data-testid="intro-agency-link"
              className="group py-6 md:py-8 md:pl-8 transition-colors duration-300 hover:bg-black/[0.02]"
            >
              <div className="flex items-center justify-between">
                <span className="overline">Brand &amp; Agency</span>
                <span
                  aria-hidden
                  className="text-black/40 group-hover:text-[#c9a878] transition-all duration-500 group-hover:translate-x-1"
                >
                  →
                </span>
              </div>
              <p className="mt-2 font-serif-display text-2xl md:text-3xl transition-transform duration-500 group-hover:translate-x-1">
                Local &amp; <span className="italic-display">nationwide</span>
              </p>
              <p className="mt-2 text-[13px] text-[#5a6470]">
                Brand systems · Social strategy · Commercial films
              </p>
              <span className="mt-3 inline-block overline text-black/50 group-hover:text-[#c9a878] transition-colors">
                Explore agency ↘
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
